import * as React from 'react';
import type {
  LogicProps,
  VerticalMenuProps,
  VerticalMenuImperativeActions,
} from '../VerticalMenu.types';
import extendItemsWithSelectionProp from './utils/extendItemsWithSelectionProp';
import filterVisibleItems from './utils/filterVisibleItems';
import VerticalMenuCommonSkin from './skinComps/VerticalMenuCommonSkin';

const VerticalMenuRoot: React.ForwardRefRenderFunction<
  VerticalMenuImperativeActions,
  VerticalMenuProps & LogicProps
> = (props, ref) => {
  const { a11y, ariaAttributes, translations, items = [], currentUrl } = props;
  const visibleItems = React.useMemo(() => filterVisibleItems(items), [items]);
  const itemsWithSelectionProp = React.useMemo(
    () => extendItemsWithSelectionProp(currentUrl, visibleItems),
    [currentUrl, visibleItems],
  );

  return (
    <VerticalMenuCommonSkin
      {...props}
      ref={ref}
      items={itemsWithSelectionProp}
      ariaLabel={ariaAttributes?.label ?? a11y?.label ?? translations.ariaLabel}
    />
  );
};

export default React.forwardRef(VerticalMenuRoot);
